var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "profile-placeholder_svg__a",
    cx: 40,
    cy: 40,
    r: 40
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "profile-placeholder_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#profile-placeholder_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#EFEFEF",
    xlinkHref: "#profile-placeholder_svg__a"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    mask: "url(#profile-placeholder_svg__b)",
    cx: 40.465,
    cy: 77.674,
    r: 28.372
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    mask: "url(#profile-placeholder_svg__b)",
    cx: 40.465,
    cy: 30.233,
    r: 13.488
  }))));
}
export default SvgProfilePlaceholder;